module.exports = __webpack_public_path__ + "img/img_cion.8a1d68d3.png";